angular.module('app.cessao').factory('cessaoHubFactory', function ($http, errorService) {
    var _apiName = 'CessaoHub';

    var _obterResumo = function (codigo) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ObterResumo', { Codigo: codigo });
    };

    function _dispararDownload(response) {
        var headers = response.headers();
        var filename = "";

        var disposition = headers["content-disposition"];
        if (disposition && disposition.indexOf('attachment') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '');
            }
        }

        var blob = new Blob([response.data], { type: headers['content-type'] });
        var url = window.URL.createObjectURL(blob);

        var linkElement = document.createElement('a');
        linkElement.setAttribute('href', url);
        linkElement.setAttribute("download", filename);

        var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": false
        });
        linkElement.dispatchEvent(clickEvent);
    }

    function _extrairErro(response) {
        if (response.data instanceof ArrayBuffer) {
            try {
                var texto = new TextDecoder('utf-8').decode(response.data);
                response.data = JSON.parse(texto);
            } catch (e) {
                return response;
            }
        }

        // response.data.Message vem como texto genérico ("An error has occurred.");
        // a mensagem real da exceção fica em ExceptionMessage.
        if (response.data && response.data.ExceptionMessage) {
            response.data.Message = response.data.ExceptionMessage;
        }

        return response;
    }

    function _baixarArquivo(endpoint, dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/' + endpoint, dto, {
            responseType: 'arraybuffer'
        }).then(_dispararDownload, function (response) {
            errorService.processError(_extrairErro(response));
            throw response;
        });
    }

    var _obterRelatorioRemessaFundo = function (codigoRemessaFundo) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoRemessaFundo", "value": codigoRemessaFundo });

        return _baixarArquivo('ObterRelatorioRemessaFundo', dto);
    };

    var _obterRelatorioCessao = function (codigoCessao) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoCessao", "value": codigoCessao });

        return _baixarArquivo('ObterRelatorioCessao', dto);
    };

    var _obterTermoCessao = function (codigo, codigoCessaoDocumento) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "Codigo", "value": codigo });
        dto.parms.push({ "name": "CodigoCessaoDocumento", "value": codigoCessaoDocumento });

        return _baixarArquivo('ObterTermoCessao', dto);
    };

    var factory = {};

    factory.obterResumo = _obterResumo;
    factory.obterRelatorioRemessaFundo = _obterRelatorioRemessaFundo;
    factory.obterRelatorioCessao = _obterRelatorioCessao;
    factory.obterTermoCessao = _obterTermoCessao;

    return factory;
});